import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import prod1 from '../../img/prods/orane-removebg-preview.png';
import prod33 from '../../img/prods/vvv.png';
import prod2 from '../../img/prods/download.png';
import prod3 from '../../img/prods/images- Fresh mandarin.png';
import prod4 from '../../img/prods/png-transparent-bunch-of-white-grapes-muscat-wine-juice-concord-grape-grape-natural-foods-food-wine-thumbnail.png';
import prod5 from '../../img/prods/png-transparent-strawberry-fruit-strawberry-strawberry-clipart-thumbnail.png';
import prod6 from '../../img/prods/png-transparent-pomegranate-juice-fruit-food-pomegranate-natural-foods-frutti-di-bosco-dried-fruit-thumbnail.png';
import prod7 from '../../img/prods/Bunch-Carrots.png';
import prod8 from '../../img/prods/red-removebg-preview.png';
import prod9 from '../../img/prods/png-transparent-chili-red-chili-vegetables-thumbnail.png';
import prod10 from '../../img/prods/png-transparent-garlic-white-garlic-vegetables-thumbnail.png';
import prod11 from '../../img/prods/vegetable-item-5-removebg-preview.png';
import prod12 from '../../img/prods/png-clipart-red-sweet-potatoes-sweet-potato-root-vegetables-tuber-sweet-potato-food-potatoes-thumbnail.png';
import prod13 from '../../img/prods/barhi_1_0.png';
import prod14 from '../../img/prods/green-cap-removebg-preview.png';
import prod15 from '../../img/prods/B62-300x300.png';
import Aos from 'aos'
import 'aos/dist/aos.css'
export default function Products() {
  useEffect(() => {
    Aos.init({
        duration: 1000
    })

}, [])

  return (
    <>
    
<div className="container-fluid bg-primary py-5 bg-hero mb-5">
  <div className="container py-5">
    <div className="row justify-content-start">
      <div className="col-lg-8 text-center text-lg-start">
        <h1 className="display-1 text-white mb-md-4">Products</h1>
        <Link to="/" className="btn btn-primary py-md-3 px-md-5 me-3">Home</Link>
        <Link  className="btn btn-secondary py-md-3 px-md-5">Products</Link>
      </div>
    </div>
  </div>
</div>

      {/* Products Start */}
      <div className="container-fluid py-5">
        <div className="container">
          <div className="mx-auto text-center mb-5" style={{ maxWidth: '500px' }}>
            <h6 className="text-primary text-uppercase">Products</h6>
            <h1 className="display-5">Our Fresh Products</h1>
          </div>
          <div className="row text-center">
                    {/* Product 1 */}
                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item  bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod33} alt="Organic Vegetable" />
                            <h6 className="mb-3">Valencia Orange</h6>
                            <Link to='/valincia' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>

                    {/* Product 2 */}
                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item  bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod1} alt="Organic Vegetable" />
                            <h6 className="mb-3">Navel oranges   </h6>
                            <Link to='/navel' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>

                    {/* Product 3 */}
                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod2} alt="Organic Vegetable" />
                            <h6 className="mb-3">Lemons </h6>
                            <Link to='/lemon' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>

                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod3} alt="Organic Vegetable" />
                            <h6 className="mb-3"> Fresh mandarin </h6>
                            <Link to='/mandarin' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>


                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod4} alt="Organic Vegetable" />
                            <h6 className="mb-3"> Grapes </h6>
                            <Link to='/grapes' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>


                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod5} alt="Organic Vegetable" />
                            <h6 className="mb-3"> Strawberries</h6>
                            <Link to='/strawberries' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>


                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod6} alt="Organic Vegetable" />
                            <h6 className="mb-3"> Pomegranate </h6>
                            <Link to='/pomegranate' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>


                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod7} alt="Organic Vegetable" />
                            <h6 className="mb-3"> Carrots </h6>
                            <Link to='/carrot' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>


                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod8} alt="Organic Vegetable" />
                            <h6 className="mb-3"> Fresh onion
                            </h6>
                            <Link to='/onion' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>


                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod9} alt="Organic Vegetable" />
                            <h6 className="mb-3">Chili Pepper
                            </h6>
                            <Link to='/chili' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>

                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod14} alt="Organic Vegetable" />
                            <h6 className="mb-3">capsicum (pepper)
                            </h6>
                            <Link to='/capsicum' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>


                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod10} alt="Organic Vegetable" />
                            <h6 className="mb-3"> Fresh Garlic
                            </h6>
                            <Link to='/garlic' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>


                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod11} alt="Organic Vegetable" />
                            <h6 className="mb-3"> Fresh Potato
                            </h6>
                            <Link to='/potato' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>


                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod12} alt="Organic Vegetable" />
                            <h6 className="mb-3">Fresh sweet potato
                            </h6>
                            <Link to='/sweet-potato' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>


                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod15} alt="Organic Vegetable" />
                            <h6 className="mb-3">  Capucha Lettuce </h6>
                            <Link to='/capucha' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>

                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod13} alt="Organic Vegetable" />
                            <h6 className="mb-3"> Barhi </h6>
                            <Link to='/barhi' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>


                </div>
        </div>
      </div>
      {/* Products End */}
    </>
  );
}
